module.exports = __webpack_public_path__ + "static/iso_5.0a093cfc.jpg";